import { render, staticRenderFns } from "./messegeDetail.vue?vue&type=template&id=436ef1b6&"
import script from "./messegeDetail.vue?vue&type=script&lang=js&"
export * from "./messegeDetail.vue?vue&type=script&lang=js&"
import style0 from "./messegeDetail.vue?vue&type=style&index=0&id=436ef1b6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports